module.exports = __webpack_public_path__ + "img/GS.7b917516.svg";